import { render } from "./DemoDashboardLayout.vue?vue&type=template&id=78928938&scoped=true"
import script from "./DemoDashboardLayout.vue?vue&type=script&lang=js"
export * from "./DemoDashboardLayout.vue?vue&type=script&lang=js"

import "./DemoDashboardLayout.vue?vue&type=style&index=0&id=78928938&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78928938"]])

export default __exports__